import React, { useState } from "react";
import useFingerprintCapture from "hooks/useFingerprintCapture";
import useLocationService from "hooks/useLocationService";
import { useSession } from "hooks/useSession";
import { fetchWrapper } from "utils/apiFetch";
import { showMainToast } from "utils/showToast";
import { captureAvdm } from "utils/rdService";
function RegisterKYCModalBody({onSuccess}) {
  // const { captureAvdm, pidData, wadh, loading } = useFingerprintCapture();
  
  const { location, permission, getLocation, checkPermission } = useLocationService(false);
  const { userid } = useSession();

  const [formData, setFormData] = useState({
    selectedDevice: "mantra",
    consentGiven: true,
  });
  const [pidData, setpidData] = useState('');
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [responseMsg, setResponseMsg] = useState(null);
  const closeModal = () => {
    const modalEl = document.getElementById("modalAlwaysFullscreen");
    if (modalEl) {
      const instance = window.bootstrap.Modal.getInstance(modalEl);
      if (instance) instance.hide();
    }
  };
  
  const handleDeviceSelection = (value) => {
    setFormData((prev) => ({ ...prev, selectedDevice: value }));
    setErrors((prev) => ({ ...prev, selectedDevice: "" }));
  };

  const handleCheckboxChange = (e) => {
    const { checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      consentGiven: checked,
    }));
  
    if (errors.consentGiven) {
      setErrors((prev) => ({
        ...prev,
        consentGiven: "",
      }));
    }
  };
  

  const handleCapture = async () => {
    const response = await captureAvdm(formData.selectedDevice, "");
    if (response.success) {
      setpidData(response.data);
      console.log("PID XML:", response.data);
    } else {
      alert("Error: " + response.error);
    }
  };

  const handleSubmit = async () => {
    setErrors({});
    setResponseMsg(null);

    // ✅ Validation
    if (!formData.consentGiven) {
      setErrors({ consentGiven: "You must give consent to continue." });
      return;
    }
    if (!pidData) {
      setErrors({ pidData: "Please scan your fingerprint first." });
      return;
    }

    setSubmitting(true);

    try {
      // ✅ Ensure location fetched
      let lat = location.lat;
      let lng = location.lng;

      if (!lat || !lng) {
        const loc = await getLocation();
        if (loc) {
          lat = loc.lat;
          lng = loc.lng;
        } else {
          throw new Error("Unable to fetch location.");
        }
      }

      // ✅ Build request payload
      const formPayload = new FormData();
      formPayload.append("userid", userid);
      formPayload.append("transaction_platform", "WEB");
      formPayload.append("lat", lat);
      formPayload.append("long", lng);
      formPayload.append("finger_code", pidData);

      console.log("Submitting FormData:", {
        userid,
        transaction_platform: "WEB",
        lat,
        long: lng,
        xml_data: pidData,
      });
      // ✅ POST Request
      const res = await fetchWrapper("https://pro.mokshiq.in/aeps_registration", {
        method: "POST",
       
        body: formPayload,
      });

     

      if (!res.status) throw new Error(res.data || "Submission failed");
      if (onSuccess) onSuccess(res.data);
      closeModal(); 
      showMainToast(res.data, "success");
    } catch (err) {
      console.error("Submit error:", err);
      showMainToast(`❌ ${err.message}`, "danger");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <div className="modal-body">
        {/* Select Fingerprint Device */}
        <div className="col-md-6 col-xl-12">
          <div className="card equal-card">
            <div className="card-body">
              {errors.selectedDevice && (
                <div className="text-danger mb-2">{errors.selectedDevice}</div>
              )}
              <div className="form-selectgroup">
                <div className="row g-3">
                  {[
                    {
                      id: "mantra",
                      name: "MANTRA",
                      img: "../assets/images/service/mantra.png",
                      text: "Select Mantra",
                    },
                    {
                      id: "morpho",
                      name: "MORPHO",
                      img: "../assets/images/service/morpho.jpeg",
                      text: "Select Morpho",
                    },
                    {
                      id: "startek",
                      name: "STARTEK",
                      img: "../assets/images/service/startek.jpg",
                      text: "Select Startek",
                    },
                    {
                      id: "evolute",
                      name: "EVOLUTE",
                      img: "../assets/images/service/evolute.jpg",
                      text: "Select Evolute",
                    },
                  ].map((device) => (
                    <div className="col-sm-6 col-lg-3" key={device.id}>
                      <div className="select-item">
                        <input
                          className="form-check-input"
                          id={device.id}
                          name="deviceOption"
                          type="radio"
                          value={device.id}
                          checked={formData.selectedDevice === device.id}
                          onChange={() => handleDeviceSelection(device.id)}
                        />
                        <label className="form-check-label" htmlFor={device.id}>
                          <span className="d-flex align-items-center">
                            <img alt="" className="w-30 h-30" src={device.img} />
                            <span className="ms-2">
                              <span className="fs-6">{device.name}</span>
                              <span className="d-block text-secondary">
                                {device.text}
                              </span>
                            </span>
                          </span>
                        </label>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Consent Checkbox */}
        <div class="form-check mt-3">
  <input
    class="form-check-input"
    type="checkbox"
    id="consentGiven"
    checked={formData.consentGiven}
    onChange={handleCheckboxChange}
  />
  <label class="form-check-label text-success" for="consentGiven">
    I hereby provide my consent to CSP to use my Aadhaar number/VID to
    complete AEPS transaction authorisation.
  </label>
</div>


        {errors.consentGiven && (
          <div className="text-danger mt-2">{errors.consentGiven}</div>
        )}

        {/* Fingerprint Scan */}
        <center className="mt-3">
          <button
            onClick={handleCapture}
            className="btn btn-outline-primary p-0"
            style={{ width: "80px", height: "80px" }}
            type="button"
            
          >
            <img
              src="../assets/images/service/scan.gif"
              alt="Gif Button"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </button>
          {errors.pidData && (
            <div className="text-danger mt-2">{errors.pidData}</div>
          )}
        </center>
      </div>

      <div className="modal-footer">
        <button className="btn btn-secondary" data-bs-dismiss="modal">
          Close
        </button>
        <button
          className="btn btn-primary"
          onClick={handleSubmit}
          disabled={submitting}
        >
          {submitting ? "Submitting..." : "Submit"}
        </button>
      </div>

      {responseMsg && (
        <div className="text-center mt-2">
          <small>{responseMsg}</small>
        </div>
      )}
    </div>
  );
}

export default RegisterKYCModalBody;
